
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/detail/[ticker]",
      function () {
        return require("private-next-pages/detail/[ticker]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/detail/[ticker]"])
      });
    }
  